<div class="dialog-header_inner">
  <ng-content></ng-content>
</div>
@if (headerSubtitle) {
  <span class="dialog-header_subtitle">{{ headerSubtitle | translate: headerSubtitleParams }}</span>
}
